if (!customElements.get('ispektrum-variant-cards')) {
  customElements.define(
    'ispektrum-variant-cards',
    class IspektrumVariantCards extends HTMLElement {
      constructor() {
        super();

        this.isDragging = false;
        this.hasMoved = false;
        this.startX = 0;
        this.startScrollLeft = 0;

        this.handleChange = this.handleChange.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this.handleChange);
        this.addEventListener('pointerdown', this.handlePointerDown);
        this.addEventListener('pointermove', this.handlePointerMove);
        this.addEventListener('pointerup', this.handlePointerUp);
        this.addEventListener('pointercancel', this.handlePointerUp);
        this.addEventListener('click', this.handleClick, true);

        requestAnimationFrame(() => {
          this.scrollSelectedCard('auto');
        });
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('pointerdown', this.handlePointerDown);
        this.removeEventListener('pointermove', this.handlePointerMove);
        this.removeEventListener('pointerup', this.handlePointerUp);
        this.removeEventListener('pointercancel', this.handlePointerUp);
        this.removeEventListener('click', this.handleClick, true);
      }

      handleChange(event) {
        if (!event.target.matches('.ispektrum-variant-card-input')) return;

        requestAnimationFrame(() => {
          this.scrollSelectedCard('smooth');
        });
      }

      scrollSelectedCard(behavior) {
        const selectedInput = this.querySelector(
          '.ispektrum-variant-card-input:checked'
        );
        const selectedCard = selectedInput?.nextElementSibling;

        if (!selectedCard) return;

        const containerRect = this.getBoundingClientRect();
        const cardRect = selectedCard.getBoundingClientRect();

        const targetLeft =
          this.scrollLeft +
          cardRect.left -
          containerRect.left -
          (this.clientWidth - cardRect.width) / 2;

        const maximumLeft = this.scrollWidth - this.clientWidth;
        const finalLeft = Math.max(0, Math.min(targetLeft, maximumLeft));

        this.scrollTo({
          left: finalLeft,
          behavior: behavior
        });
      }

      handlePointerDown(event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        this.isDragging = true;
        this.hasMoved = false;
        this.startX = event.clientX;
        this.startScrollLeft = this.scrollLeft;
        
      }

      handlePointerMove(event) {
        if (!this.isDragging) return;

        const distance = event.clientX - this.startX;

        if (Math.abs(distance) > 5) {
          this.hasMoved = true;
        }

        this.scrollLeft = this.startScrollLeft - distance;
      }

      handlePointerUp() {
  if (!this.isDragging) return;

  this.isDragging = false;
}

      handleClick(event) {
        if (!this.hasMoved) return;

        event.preventDefault();
        event.stopPropagation();
        this.hasMoved = false;
      }
    }
  );
}

